import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Ubereats } from './uber-eat/ubereats.model';

@Injectable({
    providedIn: 'root'
})
export class PartnersService {

    private dns = environment.dns;

    constructor(private _http: HttpClient) { }

    /**
     * --------------------------------------------------------------
     *
     * GET CALLS
     *
     * --------------------------------------------------------------
     **/
    // public getAll(): Observable<Chr> {
    //   let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //   return this._http.get(this.dns + 'chr_caise', {
    //     headers
    //   }).pipe(map((payload: any) => {
    //     if (payload) {
    //       return payload.chr_caise;
    //     }
    //     return [0];
    //   }));
    // }
    /*
    public getAll(): Observable<Chr[]> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this._http.get(this.dns + 'chr_caise', {
            headers
        }).pipe(map((payload: any) => {
            if (payload.chr_caises) {
                return payload.chr_caises;
            }
            return [];
        }));
    }
*/

    public hubriseSettings(): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this._http.get(this.dns + 'get_hubrise_settings', {
            headers
        });
    }
    


    public updateUberEats(payload: any): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this._http.put(this.dns + 'restaurants/updateUberData', payload, {
            headers
        });
    }


    public synchroniseuber(): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this._http.post(this.dns + 'ubereat/syncArticles', {}, {
            headers
        });
    }
    public pushArticlesuber(): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this._http.post(this.dns + 'ubereat/pushArticles', {}, {
            headers
        });
    }
    public integrationuber(): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this._http.get(this.dns + 'ubereat/getIntegration', {
            headers
        });
    }
    public statusuber(): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this._http.post(this.dns + 'ubereat/status', {}, {
            headers
        });
    }
    public sendintegrationcode(code: string): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this._http.post(this.dns + 'ubereat/integration', { 'code': code }, {
            headers
        });
    }

    /**Hubrise */

    public getHubriseUrl(): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this._http.get(this.dns + 'get_hubrise_url', {
            headers
        });
    }

    public updateHubriseToken(payload: any): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this._http.post(this.dns + 'save_webhook_hubrise ', payload, {
            headers
        });
    }
}
